import React, { FC, useMemo } from 'react';
import { Form } from '@ant-design/compatible';
import ExpenseCategoryInput from '../expense_category_input/ExpenseCategoryInput';
import { connect } from 'react-redux';
import { getBuyerCompanySettingValue } from '../../utils/AuthUtils';
import { withUserType } from '../withUserType';

const CATEGORY_CONFIG = {
	capex: {
		configPath: 'capExConfig.acceptCapExCategory',
		label: 'CapEx Category',
		fieldDecoratorName: 'capExCategoryInput',
		categoryIdField: 'capExCategoryId',
		categoryField: 'capExCategory',
		showWhenCapex: true,
	},
	rm: {
		configPath: 'rmConfig.acceptRmCategory',
		label: 'R&M Category',
		fieldDecoratorName: 'rmCategoryInput',
		categoryIdField: 'rmCategoryId',
		categoryField: 'rmCategory',
		showWhenCapex: false,
	},
};

interface ExpenseCategoryFormFieldProps {
	categoryType: 'capex' | 'rm';
	isCapex: boolean;
	getFieldDecorator: any;
	formData: any;
	companyConfig?: any;
	userType?: any;
	currentUser?: any;
}

const ExpenseCategoryFormField: FC<ExpenseCategoryFormFieldProps> = ({
	categoryType,
	isCapex,
	getFieldDecorator,
	formData,
	companyConfig,
	userType,
	currentUser,
}): React.ReactElement => {
	const config = CATEGORY_CONFIG[categoryType];

	const allowCategory = useMemo(
		() => getBuyerCompanySettingValue(userType)(config.configPath, companyConfig, currentUser),
		[companyConfig, currentUser, userType, config.configPath]
	);

	const shouldShow = config.showWhenCapex ? isCapex : !isCapex;

	return allowCategory && shouldShow ? (
		<Form.Item label={config.label}>
			{getFieldDecorator(config.fieldDecoratorName, {
				initialValue: {
					[config.categoryIdField]: formData[config.categoryIdField],
					[config.categoryField]: formData[config.categoryField],
				},
			})(<ExpenseCategoryInput categoryType={categoryType} />)}
		</Form.Item>
	) : null;
};

const mapStateToProps = (state) => ({
	companyConfig: state.company_config.detail,
	currentUser: state.session.currentUser,
});

export default withUserType(connect(mapStateToProps)(ExpenseCategoryFormField));
